import script from "./AdhocWarningModal.vue?vue&type=script&setup=true&lang=js"
export * from "./AdhocWarningModal.vue?vue&type=script&setup=true&lang=js"

import "./AdhocWarningModal.vue?vue&type=style&index=0&id=3e095fed&scoped=true&lang=css"

import exportComponent from "/go/src/bitbucket.org/VertexSecurity/core_vuejs/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3e095fed"]])

export default __exports__